'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $f_Lpresto_crud$MainView__tokenChecker__F1($thiz) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$3) => true));
}
export { $f_Lpresto_crud$MainView__tokenChecker__F1 as $f_Lpresto_crud$MainView__tokenChecker__F1 };
function $f_Lpresto_crud$MainView__renderItems__sci_Seq__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal($thiz, items, x$2) {
  return $thiz.nX($thiz.bh(items), x$2);
}
export { $f_Lpresto_crud$MainView__renderItems__sci_Seq__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal as $f_Lpresto_crud$MainView__renderItems__sci_Seq__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal };
function $f_Lpresto_crud$MainView__renderItemAdded__sci_Seq__O__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal($thiz, items, item, x$3) {
  return $thiz.nX($thiz.bh(items.bC(item)), x$3);
}
export { $f_Lpresto_crud$MainView__renderItemAdded__sci_Seq__O__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal as $f_Lpresto_crud$MainView__renderItemAdded__sci_Seq__O__Lpresto_crud$ModalHandler__Lcom_raquo_airstream_core_Signal };
//# sourceMappingURL=presto.crud$-Main-View.js.map
